var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 331,
    viewBox: "0 0 181 331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5009,
    cy: 165.5,
    r: 9.85246,
    stroke: "url(#paint0_linear_224_1620)",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5007,
    cy: 165.5,
    r: 19.8005,
    stroke: "url(#paint1_linear_224_1620)",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5006,
    cy: 165.5,
    r: 29.7486,
    stroke: "url(#paint2_linear_224_1620)",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5005,
    cy: 165.5,
    r: 38.7924,
    stroke: "url(#paint3_linear_224_1620)",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5003,
    cy: 165.5,
    r: 48.7404,
    stroke: "url(#paint4_linear_224_1620)",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5009,
    cy: 165.5,
    r: 57.7842,
    stroke: "url(#paint5_linear_224_1620)",
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4996,
    cy: 165.5,
    r: 66.8279,
    stroke: "url(#paint6_linear_224_1620)",
    strokeWidth: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4995,
    cy: 165.5,
    r: 76.776,
    stroke: "url(#paint7_linear_224_1620)",
    strokeWidth: 2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5005,
    cy: 165.5,
    r: 87.6284,
    stroke: "url(#paint8_linear_224_1620)",
    strokeWidth: 2
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5004,
    cy: 165.5,
    r: 96.6721,
    stroke: "url(#paint9_linear_224_1620)",
    strokeWidth: 2
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.499,
    cy: 165.5,
    r: 105.716,
    stroke: "url(#paint10_linear_224_1620)",
    strokeWidth: 2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5008,
    cy: 165.5,
    r: 115.664,
    stroke: "url(#paint11_linear_224_1620)",
    strokeWidth: 2
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4995,
    cy: 165.5,
    r: 124.708,
    stroke: "url(#paint12_linear_224_1620)",
    strokeWidth: 2
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5006,
    cy: 165.5,
    r: 134.656,
    stroke: "url(#paint13_linear_224_1620)",
    strokeWidth: 2
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5003,
    cy: 165.5,
    r: 144.604,
    stroke: "url(#paint14_linear_224_1620)",
    strokeWidth: 2
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4993,
    cy: 165.5,
    r: 155.456,
    stroke: "url(#paint15_linear_224_1620)",
    strokeWidth: 2
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 165.5,
    r: 164.5,
    stroke: "url(#paint16_linear_224_1620)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_224_1620",
    x1: 15.5009,
    y1: 154.647,
    x2: 15.5009,
    y2: 176.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E49A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF7FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_224_1620",
    x1: 15.5007,
    y1: 144.699,
    x2: 15.5007,
    y2: 186.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E49A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF7FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_224_1620",
    x1: 15.5006,
    y1: 134.751,
    x2: 15.5006,
    y2: 196.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E49A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF7FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_224_1620",
    x1: 15.5005,
    y1: 125.708,
    x2: 15.5005,
    y2: 205.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E49A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF7FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_224_1620",
    x1: 15.5003,
    y1: 115.76,
    x2: 15.5003,
    y2: 215.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E49A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF7FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_224_1620",
    x1: 15.5009,
    y1: 106.716,
    x2: 15.5009,
    y2: 224.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E49A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF7FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_224_1620",
    x1: 15.4996,
    y1: 97.6721,
    x2: 15.4996,
    y2: 233.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E49A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF7FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_224_1620",
    x1: 15.4995,
    y1: 87.7241,
    x2: 15.4995,
    y2: 243.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E49A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF7FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_224_1620",
    x1: 15.5005,
    y1: 76.8716,
    x2: 15.5005,
    y2: 254.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E49A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF7FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_224_1620",
    x1: 15.5004,
    y1: 67.8279,
    x2: 15.5004,
    y2: 263.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E49A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF7FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_224_1620",
    x1: 15.499,
    y1: 58.7842,
    x2: 15.499,
    y2: 272.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E49A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF7FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_224_1620",
    x1: 15.5008,
    y1: 48.8362,
    x2: 15.5008,
    y2: 282.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E49A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF7FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_224_1620",
    x1: 15.4995,
    y1: 39.7921,
    x2: 15.4995,
    y2: 291.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E49A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF7FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_224_1620",
    x1: 15.5006,
    y1: 29.8442,
    x2: 15.5006,
    y2: 301.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E49A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF7FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_224_1620",
    x1: 15.5003,
    y1: 19.8962,
    x2: 15.5003,
    y2: 311.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E49A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF7FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_224_1620",
    x1: 15.4993,
    y1: 9.0437,
    x2: 15.4993,
    y2: 321.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E49A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF7FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_224_1620",
    x1: 15.5,
    y1: 0,
    x2: 15.5,
    y2: 331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E49A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF7FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.81784812b10f4d55d0e352b27612c846.svg";
export { ForwardRef as ReactComponent };